
import { ref, inject, shallowRef} from 'vue'
import Tabbar from '@/components/tabbar/index.vue'
import { useRouter } from 'vue-router'
export default {
  components: {
    Tabbar
  },
  props:{},
  setup(props: object){

      const tabbar_index = 1,
            $http: any = inject('$http'),
            router = useRouter();

      let cls_datas: any = shallowRef([]),
          child_list = shallowRef([]),
          sld_item_id = ref(''),
          cls_datas_str =  common.getStorage('cls_datas');

      const cls_init = () => {
        cls_datas.value = JSON.parse(cls_datas_str)
        if(cls_datas.value.length > 0) {
          sld_item_id.value = cls_datas.value[0].gc_id
          child_list.value = cls_datas.value[0].child
        } 
      }

      // Is there a Storage Datas
      if(cls_datas_str) {
        cls_init()
      } else {
        let get_category_tree_fn = async () => {
          const ret = await $http.get_category_tree()
          if(ret!= null && ret.code == 200) {
            cls_datas.value = JSON.stringify(ret.data)
            cls_datas_str = cls_datas.value
            common.setStorage('cls_datas', cls_datas.value, 1)
            cls_init()
          }
        }
        get_category_tree_fn()
      }

      const left_click_fn = (item: any, index: number): void => {
        sld_item_id.value = item.gc_id
        child_list.value = item.child
        let left_obj: any = document.querySelector('.cls_left')
        // Item Size  > 4
        let height: number = (index - 3) * 100
        let temp = left_obj.scrollTop
        // Scroll Location
        const scroll_animation_fn = () => {
          requestAnimationFrame(() => {
            temp = temp + (height - temp) / 5
            left_obj.scrollTop = temp
            console.log(temp)
            if(temp < (height - 3)) {
              scroll_animation_fn()
            }
            else {
              left_obj.scrollTop = height
            }
          })
        }
        scroll_animation_fn()
      }
  
      // Go SearchList View
      const actv_search_fn = (item: any) => {
        console.log('item',item);
        
        if (item.bind_keywords == null) item.bind_keywords = ''
        const url = 'search?bind_cid=' + item.bind_cid +'&bind_keywords='+encodeURIComponent(item.bind_keywords)+'&gc_id='+item.gc_id
        console.log(url)
        router.push(url)
      }

 
      return {
        cls_datas,
        tabbar_index,
        sld_item_id,
        child_list,
        left_click_fn,
        actv_search_fn
      }
  }
}
